import { motion } from 'framer-motion'
import './SectionHeading.css'

const SectionHeading = ({ children, sub, icon }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.6 }}
    className={`section-heading ${sub ? 'section-heading--sub' : ''}`}
  >
    {icon && <span className="section-heading__icon">{icon}</span>}
    {children}
    {!sub && <div className="section-heading__line" />}
  </motion.div>
)

export default SectionHeading
